import REQUIREMENTS from "constants/requirements";

export function isConditional(
  property: (typeof REQUIREMENTS)[keyof typeof REQUIREMENTS] | undefined,
): boolean {
  return property === REQUIREMENTS.REQUIRED || property === REQUIREMENTS.OPTIONAL;
}

export function isDisabled(
  property: (typeof REQUIREMENTS)[keyof typeof REQUIREMENTS] | undefined,
): boolean {
  return property === REQUIREMENTS.DISABLED;
}
